export default __webpack_public_path__ + "static/media/earthnasa.d12a3788.jpg";